import { Services } from './services';

export class General {
    public static getAuthorizationUrl() {
        return String(Services.authorizationServiceUrl);
    }
    public static getClearingUrl() {
        return String(Services.clearingServiceUrl);
    }
}
